export class AmbientGlow {
  private video: HTMLVideoElement;
  private canvas: HTMLCanvasElement;
  private ctx: CanvasRenderingContext2D;
  private rafId: number | null = null;
  private isActive: boolean = false;

  constructor(video: HTMLVideoElement) {
    this.video = video;
    this.canvas = document.createElement('canvas');
    this.canvas.width = 10;
    this.canvas.height = 10;
    const context = this.canvas.getContext('2d', { willReadFrequently: true });
    if (!context) throw new Error('Could not get canvas context');
    this.ctx = context;
  }

  public start() {
    this.isActive = true;
    this.process();
  }

  public stop() {
    this.isActive = false;
    if (this.rafId) cancelAnimationFrame(this.rafId);
  }

  private process() {
    if (!this.isActive) return;

    if ('requestVideoFrameCallback' in this.video) {
        (this.video as any).requestVideoFrameCallback(() => this.updateGlow());
    } else {
        this.updateGlow();
        this.rafId = requestAnimationFrame(() => this.process());
    }
  }

  private updateGlow() {
    if (this.video.readyState < 2) { // HAVE_CURRENT_DATA
        this.process();
        return;
    }
    try {
      this.ctx.drawImage(this.video, 0, 0, 10, 10);
      const data = this.ctx.getImageData(0, 0, 10, 10).data;
      
      // Calculate average color
      let r = 0, g = 0, b = 0;
      for (let i = 0; i < data.length; i += 4) {
        r += data[i];
        g += data[i + 1];
        b += data[i + 2];
      }
      const count = data.length / 4;
      r = Math.round(r / count);
      g = Math.round(g / count);
      b = Math.round(b / count);

      document.documentElement.style.setProperty('--sf-vibrant-glow', `rgb(${r}, ${g}, ${b})`);
      
      if (!('requestVideoFrameCallback' in this.video)) {
          // Fallback handled by process() loop
      } else {
          this.process(); // Continue callback loop
      }
    } catch (e) {
      // Handle cases where video might not be ready
      this.process();
    }
  }
}
